import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { DashboardContext } from '@sdbn/common';
import { Station } from '../../../../../../client/model/station';
import { StationSet } from '../../../../../../client/model/station-set';
import { StationType } from '../../../../../../client/model/station-type.enum';
import { SacClientContext } from '../../../model/sac-client.context';

@Component({
    selector: 'app-sac-station-details',
    templateUrl: './sac-station-details.component.html',
    styleUrls: ['./sac-station-details.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SacStationDetailsComponent implements OnInit {

  stationType = StationType;

  sacClientContext: SacClientContext;

  station: Station;
  stationSet: StationSet;

  yardConfigSubscription: Subscription;

  @Input() dashboardContext: DashboardContext;

  @Input('stationSet') set setStationSet(stationSet: StationSet) {
    this.stationSet = stationSet;
  }

  @Input('station') set setStation(station: Station) {
    this.station = station;
  }

  @Input('sacClientContext') set setSacClientContext(sacClientContext: SacClientContext) {
    this.sacClientContext = sacClientContext;
  }

  constructor() { }

  ngOnInit(): void {
  }

}
